@if(hasErrors$ | async){
  <div class="messages">
    @for (rule of validationRule.rules; track rule) {
      @if (invalid(rule)) {
        <small
          [ngClass]="{'text-info': rule.isWarning,'text-danger': !rule.isWarning}"
          >
          {{rule.settings.message.text}}
        </small>
      }
    }
  </div>
}